import { zonedTimeToUtc } from "date-fns-tz"

import { isOnlyDate, parseDate, parseDateTime } from "./formatDate"

export const getGoogleCalendarLink = (
  city: string,
  name: string,
  date: Date,
  link?: string,
): void => {
  // превращаем строку в вид 20140127T224000Z
  const isoDate =
    new Date(
      zonedTimeToUtc(isOnlyDate(date) ? parseDate(date) : parseDateTime(date), "Europe/Moscow"),
    )
      .toISOString()
      .split(".")
      .slice(0, -1)
      .join()
      .replace(/[.:-]/g, "") + "Z"

  const icsMSG =
    "BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//Our Company//NONSGML v1.0//EN\r\nBEGIN:VEVENT\r\nDTSTAMP:20120315T170000Z\r\nDTSTART:" +
    isoDate +
    "\r\nDTEND:" +
    isoDate +
    "\r\nLOCATION:" +
    city +
    "\r\nSUMMARY:" +
    name +
    "\r\nDESCRIPTION:Информация о событии по ссылке: " +
    link +
    "\r\nEND:VEVENT\r\nEND:VCALENDAR"

  window.open("data:text/calendar;charset=utf8," + icsMSG)
}
